import { useEffect, useRef, useState } from 'react';
import { useLanguage } from './i18n';

function BuyMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const { href, messages } = useLanguage();

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="buy-menu" ref={menuRef}>
      <button
        type="button"
        className="buy-menu-button"
        aria-expanded={isOpen}
        aria-haspopup="true"
        onClick={() => setIsOpen((open) => !open)}
      >
        {messages.buy}
      </button>
      {isOpen && (
        <ul className="buy-menu-dropdown" role="menu">
          <li role="none">
            <a className="buy-menu-item" role="menuitem" href={href('/buy/russia')}>
              {messages.russia}
            </a>
          </li>
          <li role="none">
            <a className="buy-menu-item" role="menuitem" href={href('/buy/cis')}>
              {messages.cis}
            </a>
          </li>
        </ul>
      )}
    </div>
  );
}

export default BuyMenu;
